import { Typography as e } from "../../Typography/Typography.mjs";
import { Icons as t } from "../Icons/Icons.mjs";
import { IconButton as n } from "../Button/IconButton.mjs";
import { useMobile as r } from "../../hooks/useMobile.mjs";
import { useBodyScrollLock as i } from "../../hooks/useBodyScrollLock.mjs";
import { useEffect as a, useState as o } from "react";
import { keyframes as s, styled as c } from "styled-components";
import { useTranslation as l } from "@maat/store-i18n";
import { Fragment as u, jsx as d, jsxs as f } from "react/jsx-runtime";
import { createPortal as p } from "react-dom";
//#region src/components/Popup/Popup.tsx
var m = s`
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
`, h = s`
    from { opacity: 0; }
    to   { opacity: 1; }
`, g = c.div`
    position: fixed;
    inset: 0;
    z-index: 1001;
    background: ${({ theme: e }) => e.colors.card};
    display: flex;
    flex-direction: column;
    overflow: hidden;
    overscroll-behavior: contain;
    animation:
        ${m} 250ms cubic-bezier(0.4, 0, 0.2, 1),
        ${h} 150ms ease;
`, _ = c.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme: e }) => e.spacing(1, 2)};
    border-bottom: 1px solid ${({ theme: e }) => e.colors.border};
    flex-shrink: 0;
    min-height: 56px;
`, v = c.div`
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
`, y = c.div`
    flex-shrink: 0;
`;
function b(e, t) {
	let n = e !== void 0, [r, i] = o(e ?? !0);
	return a(() => {
		n && i(e);
	}, [n, e]), {
		visible: n ? e : r,
		handleClose: () => {
			n || i(!1), t?.();
		}
	};
}
var x = ({ open: e, onClose: t, children: n }) => {
	let { isMobile: a } = r(), { visible: o } = b(e, t);
	return i(a && o), a ? o ? p(/* @__PURE__ */ d(g, { children: n }), document.body) : null : /* @__PURE__ */ d(u, { children: n });
}, S = ({ open: a, onClose: o, children: s, title: c, footer: m }) => {
	let { t: h } = l("ds"), { isMobile: x } = r(), { visible: S, handleClose: C } = b(a, o);
	return i(x && S), x ? S ? p(/* @__PURE__ */ f(g, { children: [
		/* @__PURE__ */ f(_, { children: [/* @__PURE__ */ d(e, {
			variant: "h5",
			children: c ?? ""
		}), /* @__PURE__ */ d(n, {
			icon: /* @__PURE__ */ d(t.X, {
				size: 18,
				color: "#000"
			}),
			label: h("common:actions.close"),
			variant: "ghost",
			onClick: C
		})] }),
		/* @__PURE__ */ d(v, { children: s }),
		m && /* @__PURE__ */ d(y, { children: m })
	] }), document.body) : null : /* @__PURE__ */ d(u, { children: s });
};
//#endregion
export { x as MobileFullscreen, S as Popup };
